module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('app-header'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-09aad170", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09aad170","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 769
// module chunks = 1